export default {
	'common':{
		'select':'Auswählen',
		'graph_loading': "Daten werden geladen...",
		'month_Names': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		'graph_shortMonths': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		'graph_day_name': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
		'graph_export': "Exportieren",
		'graph_printButt': "Drucken",
		'graph_down_PNG': "Download als PNG-Bild",
		'graph_down_JPG': "Download als JPEG-Bild",
		'graph_down_PDF': "Download als PDF-Dokument",
		'graph_down_SVG': "Download als SVG-Bild",
		'graph_zoom_reset': "Zoom zurücksetze",
		'Valid request.': 'gültige Anfrage.',
		'Warning': 'Warnung',
	},
	'main':{
		'titleStatistics':'Statistik',
		'titleManual':'Manuell',
		'titleDownload':'Download',
		'titleArchives':'Archive',
		'titleStream':'Stream',
		'titleRealtime':'Echtzeit',
		'titlePlay':'Start',
		'titleDanger': 'Fehler/Nicht laufen',
		'titleWarning': 'Im Betrieb',
		'titleSettings':'Einstellungen',
		'titleSD':'SD frei:',
		'titleHDD':'SSD frei:',
		'titleCamera': 'Kamera:',
		'titleLogout': 'Ausloggen',
		'status':'Status',
		'error':'Fehler',
		'running':'Laufen',
		'notRunning': 'Nicht laufen',
		'downloadingFile':'Datei heruntergeladen',
		'preparingFile':'Datei vorbereiten'
	},
	'login':{
		'Username':'Benutzername',
		'Password':'Passwort',
		'Login':'Login',
	},
	'dashboard':{
		'measuringTgl':'Messung',
		'noiseTgl':'Pegel',
		'weatherTgl':'Wetter',
		'adioTgl':'ADIO',
	},
	'graphs':{
		'export':{
			'Print chart':'Ansicht anzeigen',
			'Download':'Download',
			'image':'Bild',
		},
		'nodata': "KEINE DATEN",
		'errNoise': "Problem mit Nor140",
		'errWeath': "Problem mit Wetter",
		'errAdio': "Problem mit ADIO",
		'NOISE':'Pegel',
		'SPECTRUM':'Spektrum',
		'WEATHER':'Wetter',
		'ADIO': 'ADIO',
		'STATISTICS':'STATISTIK',
		'statTitle':'Titel',
		'statFrom':'Von',
		'statTo':'Bis',
		'load':'Laden',
		'markers':'Marker',
	    'dailyNotes': 'Tägliche Notizen',
	    'preload': 'Grafik manualladen',
	    'sync': 'Grafik synchrosieren',
	    'reset': 'Zoom zurücksetzen',
	    'exportGraph': 'Grafik exportieren',
	    'hideShow': 'Verbergen / Anzeigen',
		'markersCat':{
			'type':'Type',
			'color':'Farbe',
			'single': 'Punkt',
			'toggle': 'Bereich',
			'keybind': 'Tastenkombination',
			'learn':'Lernen',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete':'Löschen',
			'save': 'Speichern',
			'note':'Notizen',
		},
		'markersTable':{
			'name':'Name',
			'startTime': 'Start Zeit',
			'endTime': 'Stop Zeit',
			'type': 'Type'
		}
	},
	'calendar': {
		'title': 'Kalender',
		'noise':'Pegel',
		'audio':'Audio',
		'weather':'Wetter',
		'video':'Video',
		'adio':'ADIO',
	},
	'streamPopover':{
		'title':'Streams',
		'Audio':'Audio',
		'Video':'Video',
		'StartManRec': 'Manuelle Aufzeichnung',
		'StopManRec': 'Aufzeichnung beenden',
		'StartStream': 'Start Stream',
		'StopStream': 'Stop Stream',
	},
	'download':{
		'title':'Downloads',
		'popOver':{
			'XML':'Export NorReview',
			'XMLWeekly':'Wöchentliche Daten exportieren',
			'Raw':'Raw daten',
			'Global':'Globale Ergebnisse',
			'weather':'TXT Wetter',
		}
	},
	'archives':{
		'popOver':{
			'Global':'Global Ergebnisse',
			'Noise':'Pegel',
			'Audio':'Audio',
			'Video':'Video',
			'Weather':'Wetter',
			'Adio': 'ADIO',
			'Compressed': 'Komprimiert',
		},
		'audioPopOver':{
			'downlRec': 'Download Aufzeichnung',
			'range': 'Angebot',
		},
		'video':'Video',
		'global':'Globale Ergebnisse',
		'weather':'Wetter',
		'noise':'Pegel',
		'audio':'Audio',
		'name':'Archive',
		'Delete':'Löschen',
		'Download':'Download',
		'NorReview':'NorReview',
		'Thumbnail':'Vorschaubild',
		'Filename':'Dateiname',
		'Duration':'Dauer',
		'Size':'Größe',
		'Close':'schliessen',
		'adio': 'ADIO',	
		'compressed': 'KOMPRIMIERTE DATEIEN',
	}, 
	'settings':{
		'name':'Einstellungen',
		'save':'Speichern',
		'addButt': "Hinzufügen",
		'preTrigg': 'Vor-Trigger',
		'Trigg': 'Trigger',
		'postTrigg':'Nach-Trigger',
		'warning': 'Warnung',
		'continue': 'Weiter',
		'cancel': 'Abbruch',

		'interface':{
			'settingsName':'Ansicht',
			'Realtime display':'Echtzeitanzeige [sec]',
			'Language':'Sprache',
			'Lt':'L/t Bereich wählen',
			'Spectrum':'L/f Bereich wählen',
			'Weather':'Wetter Bereich wählen',
			'Adio': 'ADIO Bereich wählen',
			'Manual':'Manueller Bereich',
			'Dynamic':'Automatischer Bereich',
			'noiseTriggerLevel':'Triggerschwelle im Pegel anzeigen',
			'spectrumTriggerLevel':'Spektrum trigger level',
			//Options
			'english':'Englisch (EN)',
			'austria':'Deutsch (AT)',
			'german':'Deutsch (DE)',
			'french':'Französisch (FR)',
			'slovensko':'Slowenisch (SLO)',
		},
		'download':{
			'settingsName':'Download',
			'Compression':'Komprimierung',
			'No compression':'Keine Komprimierung',
			'Zip compression':'Zip Komprimierung (spart Datenvolumen)',
			'Noise':'Pegel',
			'Weather':'Wetter',
			'Global Values':'Globale Ergebnisse',
			'Special values':'Zusatz Werte',
			'Audio':'Audio',
			'Video':'Video',
			'Markers':'Markers',
			'Statistics':'Statistik',
			'statisticsTemplate':'Vorlage',
			'statisticsRename':"Vorlage umbenennen"
		},
		'audioRecording':{
			'settingsName':'Audio aufzeichnung',
			'Format':'Format',
			'Audio Offset':'Vor-Trigger: [s]',
			'Day':'Tag',
			'Night':'Nacht',
			'Optional 1':'Optional 1',
			'Optional 2':'Optional 2',
			'RecDur':'Aufzeichnungsdauer (s)',
			'Threshold':'Überschreitungspegel (dBA)',
			'Start':'Start Zeit (HH)',
			'Stop':'Stop Zeit (HH)',
			'Weather':'Wetter Trigger',
			'Windspeed':'Windgeschwindigkeit',
			'Temperature':'Temperatur',
			'Air':'Luftdruck',
			'Precipitation':'Precipitation',
			'Humidity':'Feuchtigkeit',
			//Options
			'Disable':'Deaktiviert',
			'Lower':'Kleiner als',
			'Greater':'Größer als',
			'Both':'Gleich',
			'lowerThan':'Kleiner als',
			'greaterThan':'Größer als',
		},
		'dynamicDns':{
			'settingsName':'Dynamic Dns',
			'Address':'Adresse',
			'Provider':'Anbieter',
			'Username':'Benutzername',
			'Password':'Kennwort',
			'IP':'IP',
		},
		'alertMessaging':{
			'settingsName':'Alarm Meldung',
			'createGroupButton':'Neue Gruppe erstellen',
			'createGroupDialog':'Möchten Sie wirklich eine neue Gruppe erstellen?',
			'deleteGroupDialog':'Bestätigen Sie hier die Löschung von Gruppe ',
			'deleteEmailDialog':'Möchten Sie wirklich diese E-Mail/Mobilnummer löschen?',
			'dialogConfirm':'Bestätigen',
			'dialogContinue':'Weiter',
			'dialogCancel':'Abbruch',
			'MSISDN-E-Mail':'Mobilnummer/E-Mail',
			'Add MSISDN':'Mobilnummer hinzufügen',
			'Add E-mail':'E-Mail Adresse hinzufügen',
			'DeleteButton': 'Löschen',
			'DeleteGroup':'Gruppe löschen',
			'DeleteRecip': 'Empänger löschen',
			'DeleteEmail':'E-Mail Mobilnummer löschen',
			'TestEmail':'Test E-Mail / SMS senden',
			'Resend after':'Erneut senden nach',
			'Threshold day':'Überschreitung Tag',
			'Threshold Night':'Überschreitung Nacht',
			'Threshold Opt 1':'Überschreitung Opt. 1',
			'Threshold Opt 2':'Überschreitung Opt. 2',
			'Running Average Level':'laufender LAeq',
			'Weather trigger': 'Überschreitung Wetter',
			'System reboot':'System Neustart',
			'Connection with meter lost':'Verbindung zum Nor140 verloren',
			'FTP server error':'FTP-Server Error',
			'Critical memory on meter':'Geringer Speicherplatz SD-Karte Nor140',
			'Critical disk space':'Geringer Speicherpaltz HDD',
			'Microphone check error':'Mikrofon Check',
			'Battery mode':'230V verloren',
			'Connection with Weather station lost':'Verbindung zur Wetterstation verloren',
			'LEQ':'Leq Tag',
			'Inbound (MSISDN)':'SMS Anfragen:',
			'Status':'Status',
			'GPS':'GPS:',
			'Threshold change':'Überschreitungspegel ändern:',
			'Email settings':'E-Mail einstellungen',
			'Sender Email':'Absender E-Mail',
			'Password':'Passwort',
			'SMTP server':'SMTP server',
			'SMTP port':'SMTP port',
			'noRepeat':'keine Wiederholung',
			'resendAft':'erneut senden',
			//Options
			'min':'min',
			'disabled':'Deativieren',
			'groupsError':'Bitte wählen Sie Gruppen!',
			'emailSent':'Nachricht gesendet'
		},
		'FTPSending':{
			'settingsName':'FTP-Daten senden',
			'FTP Address':'FTP-Adresse',
			'Refresh Rate':'Aktualisierungsrate',
			'Username':'Benutzername',
			'Password':'Passwort',
			'Port':'Port',
			'Values':'Messdaten die versendet werden sollen',
			//Options
			'Disable':'Deaktivieren',
			'sec':'Sek.',
			'min':'Min',
			'hour':'Stunde',
			'measur':'Pegel',
			'weath':'Wetter',
			'audio':'Audio',
			'global':'Global Ergebnisse',
			'video':'Video',
		},
		'geographicPosition':{
		'settingsName':'Geografische Position',
			'Latitude': 'Geografische Breite[°]',
			'Longitude':'Geografische Länge[°]',
			'Height':'Höhe[m]',
		},
		'weather':{
			'settingsName':'Wetter',
			'Weather':'Wetterstation',
			'values':'Messdaten',
			'SetDevice':'Wetterstations Model',
			//Options
			'NoWeather':'Keine Wetterstation',
			'reinhardt':'Reinhardt MWS 5MV',
			'reinhardtRain':'Reinhardt MWS 5MV mit Regen',
			'thiesClima':'Thies Clima Sensor US',
			'vaisala':'Vaisala WXT520',
			'kw360': 'ONWA KW-360',
		},
		'delete':{
			'settingsName':'Löschen/Kompresse',
			'autoDelete':'Automatisch löschen älter als',
			'autoCompress':'Automatisch komprimieren älter als',
			'Disable':'Deaktiviert',
			'Manual delete':'Manuel löschen',
			'Values':'Ergebnisse',
			'Delete':'Löschen',
			//Options
			'day':'Tag(e)',
			'week':'Woche(n)',
			'month':'Monat(e)',
			'measur':'Pegel',
			'weath':'Wetter',
			'audio':'Audio',
			'global':'Global Ergebnisse',
			'logs':'Logs',
			'statistics':'Statistik',
			'video':'Video',
			'adio': 'ADIO'
		},
		'device':{
			'settingsName':'Nor140',
			'Selection':'Mikrofon Auswahl',
			'Polarisation':'Polarisations Spannung',
			'Frequency':'Frequenz Modus',
			'Resolution':'Auflösung',
			'Duration':'Messzeit',
			'Meter':'Audioausgang Skala',
			'Values':'Messwerte',
			'Special':'Zusatz Werte',
			'Advance':'Erweitert',
			'Mic check':'Mik. Check Level [dB]:',
			'Mic check time':'Mik. Check um [HH]:',
			'SDFreeSpace':'Meldung freier Speicherplatz SD-Karte [%]',
			'Restart':'Nor140 neustarten',
			'Set instrument':'Einstellungen setzen',
			'Format':'SD-Karte formatieren',
			'CheckSD':'SD-Karte prüfen',
			'formatSDdialog':'Die Formatierung kann bis zu 5 Minuten dauern, möchten Sie wirklich formatieren ?',
			'decrease':'Lautstärke runter',
			'increase':'Lautstärke hoch',
			'value':'Zeitraum',
			'threshold':'Ãœberschreitungspegel (dBA)',
			'timeControlled':'Zeitgesteuert',
			'measurementControlled':'Messung kontrolliert',
			'start_stop':'Start Zeit / Stop Zeit',
			'startTime':'Start Zeit',
			'endTime':'Endzeit',
			'trigger':'Trigger',
			'duration':'Messzeit',
			'test':'Test',
			'testOpt': 'Test auf installierte Optionen',
			'restartNoise':'Nor140 neu starten',
			'increasedVol': 'Lautstärke verringert',
			'decreasedVol': 'Lautstärke erhöht',
			'autostart': 'Auto Start-Stop',
			//Options
			'On':'Ein',
			'Off':'Aus',
			'Standard':'Standard',
			'Disable':'Deaktivieren',
			'iepe':'IEPE',
			'line':'Line',
			'horizontal':'1214/16/17 Horizontal',
			'vertical':'1214/16/17 Vertical',
			'11octave':'1/1 Octave',
			'13octave':'1/3 Octave',
			'11wOctave':'1/1w Octave',
			'13wOctave':'1/3w Octave',
			'movingAverage':'Moving Average',
			'movingValue': 'Moving value',
			'midnight': "Mitternacht - 00h",
			'noon': "Mittag - 12h",
			'freeSpace': 'Freiraum: ',
			'instrumentSent': 'Instrumentenset'	,
			'start':'Start',
			'stop':'Stop',
			'days':'Tage',
			'types':'Typen',
			'startstopActive':'Aktiv',
			'warningMeasRunning':'Einstellungen werden während einer laufenden Messung nicht übernommen!'
		},
		'video':{
			'settingsName':'Video',
			'Present':'Gegenwärtiges Gerät',
			'Manual':'Manuelle Aufzeichnung',
			'Triggering':'Überschreitungspegel Video',
			'Moving detection':'Bewegungserkennung',
			'Settings':'Einstellungen',
			'Pre':'Vor-Trigger',
			'Post':'Aufzeichnugsdauer',
			'No device':'Keine Kamera',
			'Video camera':'Videokamera',
			'SetDevice': 'Gerät einstellen',
			'formatSDWarning': 'Bitte warten Sie, bis die SD-Karte auf 100% steht',
		},
		'adio':{
			'settingsName':'ADIO',
			'Present':'Gegenwärtiges Gerät',
			'ADIO':'ADIO Box',
			'NoDevice':'Kein ADIO',
			'DigitalOut':'Digital Aus',
			'DigitalIn':'Digital In',
			'AnalogIn':'Analog In',
			'AnalogOut':'Analog Aus',
			'AnalogLowerLimit':'Analog unteres Limit 0V / 4mA',
			'AnalogUpperLimit':'Analog unteres Limit 10V / 20mA',
			'Please input':'"Bitte eingeben"',
			//Options
			'On':'Ein',
			'Off':'Aus',
		},
		'norcloud':{
			'settingsName':'NorCloud',
			'IdNor':'Nor140 ID',
			'syncTime':'Aktualisierungsrate',
			'syncData': 'Pegel senden',
			'syncRec': 'Audio senden',
			'sendAlerts': 'Alarm senden',
			'recSett': 'Einstellungen empfangen',
			'applySett': 'Empfangene Einstellungen übernehmen',
			//Options
			'On':'On',
			'Off':'Off',
			'disable':'Disable',
			'min':'min',
			'hour':'hour',
			'now': 'When settings are recevied',
			'fhour': 'At full hour',
			'break': 'When Automic check is performed',
		},
		'statistics':{
			'settingsName':'Statistik',
			'reportSending':{
				'settingsName': 'Automatic Report Sending',
				'Name': 'Name',
				'Title': 'Title',
				'Duration': 'Report type',
				'Days': 'Sending days',
				'Hours': 'Send at',
				'Range': 'Past days',
				'Email': 'E-mail', 
				'Language':'Sprache'
			},
			'options': {
				'Range': 'Range',
				'Daily': 'Daily',
				'On Event': 'On Event',
			}
		},
		'status':{
			'settingsName':'System',
			'Reboot':'System neustart',
			'Reboot confirm': 'Möchten Sie das System wirklich neu starten?',
			'Reboot success': 'Weniger als 1 Minute bis zum Neustart!',
			'Reboot cancel': 'Neustart abgebrochen',
			'Restart confirm':'Möchten Sie den N140 wirklich neu starten?',
			'Restart Warning': 'N140 wird in 1min wieder online sein!',
			'Restart success': 'N140 online!',
			'Restart cancel': 'Abgebrochen',
			'Version':'Version',
			'Release':'Veröffentlichungsdatum',
			'PCFree':'PC Speicher[%]',
			'SDD':'SDD',
			'memory':'Speicher',
			'camera':'Kamera SD',
			'n140':'Nor140 SD',
			'cpu':'CPU Leistung',
			'firmware':'Firmware',
			'logs':'Logs',
			'download':'Download',
			'total':'Gesamt',
			'free':'Frei',
			'used':'Belegt',
			'gbOrMore':'2GB oder mehr',
			'of':'of',
			'users': 'Benutzer',
			'username':'Benutzername',
			'password':'Passwort',
			'adminUsr': 'Admin',	
			'noiseUsr': 'Benutzer',
			'guestUsr': 'Gast'
        	}
	},
	'errors':{
		'n140':'Nor140',
		'weather': 'Wetter',
		'adio': 'ADIO',
		'cameraSD':'CAMERA SD-Karte über 80% voll!'
	},
	'codes':{
		"13":"Keine Serielle Verbindung",
		"16":"Software Option fehlt",
		"64":"OK - Kein Fehler",
		"89":"Messzeit zu lang für Sync.",
		"90":"Befehl Unbekannt",
		"91":"Option nicht verfügbar",
		"92":"I/O ",
		"93":"Keine Marker für den ausgewählten Bereich",
		"94":"Befehlszeichenfolge ohne Begrenzer lang",
		"97":"Geräte Fehler",
		"99":"Kein DECT Modul gefunden",
		"100":"No digit read",
		"101":"Nummer ist nicht aktzeptiert",
		"102":"Text zu Lang",
		"104":"Keine Daten",
		"105":"Zahl ist außerhalb des Bereichs",
		"106":"Messung nicht gestartet",
		"108":"Timeout on string parameter to a command",
		"109":"Software V2.X nicht Installiert",
		"110":"Fehler im Text format",
		"111":"Software V3.x nicht installiert",
		"112":"Speicher Voll",
		"116":"Speicher Fehler",
		"117":"Audiometer Calibration parameter error",
		"118":"Undefinierter Fehler (118)",
		"119":"Undefinierter Fehler (119)",
		"121":"Ordner nicht gesetzt",
		"122":"Ordner nicht gefunden",
		"123":"Speicher Prüfung OK",
		"124":"SD-Karte nicht vorhanden",
		"125":"SD-Karte nicht Unterstüzt",
		"126":"SD-Karte schreibgeschützt"
	}	
}


// WEBPACK FOOTER //
// ./src/localization/translations/local-DE.js